import { useCallback } from 'react';
import { fetchCollectionStatisticsThunk } from 'src/features/common/collection/ducks/statistics/statistics.thunk';
import { useDispatch, useSelector } from 'react-redux';
import { selectStatisticsByIds } from 'src/features/common/collection/ducks/statistics/statistics.selectors';

export const useFetchCollectionStatistics = () => {
    const dispatch = useDispatch();
    
    return useCallback((ids: string[]) => {
        dispatch(fetchCollectionStatisticsThunk(ids));
    }, [dispatch]);
};

export const useStatistics = () => useSelector(selectStatisticsByIds);
